// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M18.0755 0.980957L23.0249 5.93038L16.6602 13.7035L18.7814 15.8248L13.476 21.1302L8.87986 16.534L2.16226 23.2516L0.748047 21.8374L7.46565 15.1198L2.86942 10.5236L8.17482 5.2182L10.2962 7.33958L18.0755 0.980957Z"}}]};

const PinFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'pin-filled',
    ref,
    icon: element,
  },
));

PinFilledIcon.displayName = 'PinFilledIcon';

export default PinFilledIcon;
